{
  "table": {
    "client": "Cliente",
    "workflow": "Flujo de trabajo",
    "section": "Sección",
    "step": "Paso",
    "state": "Estado",
    "started": "Iniciado",
    "objectTypes": {
      "ACCOUNT": "Cuenta",
      "ACCOUNT_GROUP": "Grupo de cuentas",
      "GOAL": "Meta",
      "HOUSEHOLD": "Hogar",
      "SUB_ACCOUNT": "Subcuenta",
      "USER": "Usuario"
    }
  },
  "title": "Título",
  "subtitle": "Subtítulo",
  "state": "Estado",
  "icon": "Ícono",
  "applied": "Aplicado",
  "source": "Fuente",
  "startWorkflow": "Iniciar {{workflowName}}",
  "caughtUp": "Ya está al día",
  "caughtUpSubtitle": "Ahora está esto con otra persona en el flujo. Vuelva más tarde, por favor.",
  "closeWorkflow": "Cerrar flujo de trabajo",
  "pasteWarning": "Como función beta, pegar configuraciones de flujo de trabajo puede causar problemas. Utilícela con precaución y pruébela primero en un entorno seguro. Las restricciones de perfil de rol no son compatibles y se eliminarán al cargarlas.",
  "workflowUpdated": "Flujo de trabajo actualizado",
  "workflowIssues": "Flujo de trabajo actualizado, pero tiene advertencias",
  "roleProfileNotFound": "Había un perfil de rol en el paso {{subStep}}, en «{{step}}», que no se encontró en esta organización, por lo que se han eliminado todas las restricciones de perfil de rol de la configuración de ese paso.",
  "goalWorkflowNotFound": "Había un flujo de trabajo de objetivo en el paso {{subStep}}, en «{{step}}», que no se encontró en esta organización, por lo que se ha eliminado de la configuración.",
  "customFieldNotFound": "El campo personalizado «{{customField}}» del paso {{subStep}}, en «{{step}}», no se ha encontrado en esta organización, por lo que se ha eliminado de la configuración.",
  "skippable": "Omitible",
  "skip": "Omitir",
  "editCode": "Editar código",
  "copy": "Copiar configuración del flujo de trabajo",
  "paste": "Pegar configuración del flujo de trabajo",
  "continue": "Continuar",
  "canGoBack": "Se puede volver atrás",
  "addRoleProfileToWorkflow": "Añadir un perfil de rol a un flujo de trabajo",
  "completeableBy": "Las funciones pueden completarse",
  "update": "Actualizar",
  "remove": "Eliminar",
  "create": "Crear",
  "add": "Añadir",
  "workflowName": "Nombre del flujo de trabajo",
  "workflowState": "Estado del flujo de trabajo",
  "trigger": "Desencadenar",
  "event": "Evento",
  "createAnotherAccount": "Crear otra cuenta",
  "createAnotherGoal": "Crear otra meta",
  "workflow": "Flujo de trabajo",
  "section": "Sección",
  "step": "Paso",
  "triggerType": {
    "MANUAL": "Manual",
    "EVENT": "Basado en eventos"
  },
  "schedule": {
    "ONE_TIME": "Una vez",
    "WEEKLY": "Semanal",
    "BI_WEEKLY": "Quincenal",
    "SEMI_MONTHLY": "Dos veces al mes",
    "MONTHLY": "Mensual",
    "QUARTERLY": "Trimestral"
  },
  "eventType": {
    "CREATED": "Creado por el cliente",
    "PERSONAL_INFORMATION_UPDATED": "Información personal identificable actualizada",
    "SUITABILITY_SCORE_UPDATED": "Puntuación de idoneidad actualizada",
    "SUITABILITY_REVIEW_DUE": "Se requiere revisión KYC",
    "INTEGRATION_FORM_CREATED": "Formulario generado externamente",
    "ENTITY_INVITED": "Cliente invitado",
    "ACCOUNT_AFFILIATE_UPDATED": "Afiliado de cuenta actualizado",
    "SCHEDULED_TRANSFER_UPDATED": "Transferencia programada actualizada",
    "SCHEDULED_TRANSFER_CANCELED": "Transferencia programada cancelada"
  },
  "customAttributeLabels": {
    "disabledInfo": "La personalización de estas opciones se establece a nivel de organización. Ajuste estas configuraciones en el menú Etiquetas de atributos personalizados."
  },
  "saveWorkflow": "Guardar flujo de trabajo",
  "savedWorkflowMessage": "Flujo de trabajo guardado",
  "addStep": "Añadir paso",
  "addSection": "Añadir sección",
  "name": "Nombre",
  "description": "Descripción",
  "level": "Nivel",
  "eventTriggerRule": {
    "field": "Campo",
    "comparison": "Comparación",
    "value": "Valor",
    "addNewRule": "Añadir regla"
  },
  "investmentKnowledge": {
    "NONE": "Ninguno",
    "SOME": "Algunos",
    "LIMITED": "Limitado",
    "EXPERT": "Experto"
  },
  "riskLevels": {
    "LEVEL_1": "Nivel 1",
    "LEVEL_2": "Nivel 2",
    "LEVEL_3": "Nivel 3",
    "LEVEL_4": "Nivel 4",
    "LEVEL_5": "Nivel 5"
  },
  "timeHorizon": {
    "VERY_SHORT_TERM": "A muy corto plazo",
    "SHORT_TERM": "A corto plazo",
    "MID_TERM": "A mediano plazo",
    "LONG_TERM": "A largo plazo",
    "VERY_LONG_TERM": "A muy largo plazo"
  },
  "household": {
    "create": "Crear nuevo hogar",
    "createSubmit": "Crear hogar",
    "join": "Unirse al hogar existente",
    "joinSubmit": "Unirse a hogar",
    "name": "Nombre del hogar",
    "relationshipToPrimaryContact": "Relación con el contacto principal",
    "permissions": "Permisos",
    "feeGrid": "Tabla de tarifas",
    "billingSchedule": "Calendario de facturación"
  },
  "listTileStates": {
    "ENABLED": "Habilitado",
    "DISABLED": "Deshabilitado"
  },
  "goals": {
    "goal": "Meta",
    "type": "Tipo de meta",
    "start": "Iniciar",
    "newGoalPrefix": "Nueva meta",
    "addGoal": "Añadir meta",
    "createGoals_one": "Crear {{count}} meta",
    "createGoals_other": "Crear {{count}} metas",
    "scopeLabel": "¿Es esta una meta individual o familiar?",
    "scopes": {
      "INDIVIDUAL": "Individual",
      "HOUSEHOLD": "Hogar"
    },
    "selectHousehold": "Seleccionar hogar",
    "existingGoals": "Metas existentes",
    "draftGoals": "Metas provisionales",
    "riskQuestion1": "¿Cuánto riesgo está dispuesto a asumir con esta meta?",
    "riskQuestion1Responses": {
      "LEVEL_1": "No estoy dispuesto a perder nada.",
      "LEVEL_3": "Estoy dispuesto a soportar algunas pérdidas a corto plazo a cambio de un potencial de rendimiento moderado.",
      "LEVEL_5": "Estoy dispuesto a soportar mayores pérdidas a corto plazo a cambio del mayor potencial de rentabilidad."
    },
    "applyPortfolioAtGoal": "Aplicar cartera a la meta",
    "portfolioTheme": "Tema de la cartera",
    "portfolioModel": "Seleccionar el modelo",
    "taxOptimized": "Impuesto optimizado",
    "taxOptimizedInfo": "Una cartera y/o meta optimizadas fiscalmente se refiere a la aplicación de la estrategia de compensación de pérdidas fiscales (TLH, por sus siglas en inglés). Esto implica la venta de valores que han caído por debajo de su precio de compra para generar pérdidas de capital realizadas, de modo que puedan utilizarse para reducir los impuestos sobre las ganancias de inversión compensando las ganancias de capital realizadas.",
    "suitability": {
      "info": "Utilice las puntuaciones de idoneidad siguientes para seleccionar el nivel de riesgo óptimo para la cartera.",
      "goalSuitabilityScore": "Puntuación de idoneidad de la meta",
      "individualSuitabilityScore": "Puntuación de idoneidad de {{name}}"
    },
    "accountLinking": {
      "title": "Vincular meta a cuenta(s)",
      "info": "Esto genera una subcuenta para configurar el tema y el producto de su cartera. Puede optar por realizar este paso más tarde.",
      "inputLabel": "Cuenta(s)"
    },
    "details": {
      "type": "Tipo de meta",
      "name": "Nombre de meta",
      "scope": "Alcance de meta",
      "timeHorizon": "Horizonte temporal",
      "targetAmount": "Importe de meta",
      "riskTolerance": "Tolerancia al riesgo",
      "portfolioTheme": "Tema de la cartera",
      "portfolioModel": "Modelo",
      "taxOptimized": "Impuesto optimizado",
      "accountsLinked": "Cuentas vinculadas"
    }
  },
  "relatedEntities": {
    "summaryTable": {
      "name": "Nombre",
      "relation": "Relación"
    },
    "formTitle": "Añadir relación",
    "noRelations": "Sin relaciones",
    "addRelation": "Añadir relación",
    "newRelatedEntitySuccess": "Se ha añadido una nueva relación"
  },
  "subAccounts": {
    "summaryTable": {
      "goal": "Meta",
      "account": "Cuenta",
      "product": "Tema/producto de la cartera",
      "noSubAccounts": "Sin subcuentas",
      "productNotSet": "No configurado"
    },
    "suitability": {
      "title": "Puntuación de idoneidad",
      "info": "Utilice las puntuaciones de idoneidad para seleccionar el nivel de riesgo adecuado para esta subcuenta."
    },
    "formTitle": "Meta {{goalName}} y Cuenta {{accountName}}",
    "requireIPS": "Se requiere una declaración de política de inversión",
    "allowFractionalShares": "Permitir acciones fraccionadas",
    "allowClientDeposits": "Permitir depósitos de clientes",
    "linkSubAccount": "Vincular subcuenta",
    "subAccountLiquidated": "Subcuenta liquidada",
    "warningModal": {
      "title": "Falta la cartera para {{numSubAccounts}} subcuenta{{pluralSuffix}}",
      "body": "Olvidó configurar el tema y el producto de la cartera para {{numSubAccounts}} subcuenta{{pluralSuffix}}.",
      "cancelButtonLabel": "Cancelar",
      "confirmButtonLabel": "Continuar de todos modos",
      "returnButtonLabel": "Continuar editando"
    }
  },
  "createAccountButtonTitle": "Crear ({{number}}) cuenta",
  "createTransferButtonTitle": "Iniciar transferencia ({{number}})",
  "createTransfersButtonTitle": "Iniciar transferencias ({{number}})",
  "start": "Iniciar",
  "accountType": "Tipo de cuenta",
  "accountReviewPanel": {
    "tfsa": "TFSA",
    "cash": "Efectivo",
    "rrsp": "RRSP",
    "respSingle": "RESP - Individual",
    "jointRespSingle": "RESP conjunto - Individual",
    "jointRespFamily": "RESP conjunto - Familia",
    "jointCash": "Efectivo conjunto",
    "respFamily": "RESP - Familia",
    "respAdult": "RESP - Adulto",
    "corporateCash": "Efectivo corporativo",
    "successor": "Sucesor:",
    "affiliate": "Afiliado:",
    "legalGuardian": "Tutor legal:",
    "careGiver": "Cuidador:",
    "beneficiary": "Beneficiario:",
    "tableItems": {
      "name": "NOMBRE",
      "relationship": "RELACIÓN",
      "allocation": "ASIGNACIÓN"
    },
    "basicCanadaEducationSavingsGrant": "Subvención básica de ahorro para la educación en Canadá",
    "additionalCESG": "CESG adicional",
    "canadaLearningBond": "Bono de aprendizaje de Canadá"
  },
  "goalLinking": {
    "title": "Vincular la cuenta a meta(s)",
    "info": "Esto genera una subcuenta para configurar el tema y el producto de su cartera. Puede optar por realizar este paso más tarde.",
    "inputLabel": "Meta(s)",
    "goalsLinked": "Metas vinculadas"
  },
  "baseAccountCreation": {
    "addAccount": "Añadir cuenta",
    "addAffiliate": "Añadir un afiliado",
    "affiliationTable": {
      "nameHeader": "Nombre",
      "relationHeader": "Relación",
      "typeHeader": "Tipo",
      "allocationHeader": "Asignación",
      "requiredInfoHeader": "Campos incompletos"
    },
    "incompleteAffiliationWarning": {
      "title": "Creación de cuenta incompleta",
      "bodyText": "Uno o más afiliados requieren más información antes de poder conectarse a las cuentas. Proporcione la información necesaria antes de volver a intentarlo."
    }
  },
  "corporateCashAccountReivew": {
    "corporationName": "Nombre de la empresa",
    "affiliates": "Afiliados"
  },
  "corporateCashAccountCreation": {
    "title": "Efectivo corporativo - {{entityName}}",
    "authorizedIndividual": {
      "title": "Añadir a la(s) persona(s) autorizada(s)",
      "inputLabel": "Nombre de la persona autorizada"
    },
    "thirdParty": {
      "title": "Añadir el tercero",
      "inputLabel": "Nombre de terceros"
    },
    "trustee": {
      "title": "Añadir al(a los) fideicomisario(s)",
      "inputLabel": "Nombre del fideicomisario"
    },
    "settlor": {
      "title": "Añadir al fideicomitente o fideicomitentes",
      "inputLabel": "Nombre del fideicomitente"
    },
    "protector": {
      "title": "Añadir el protector o protectores",
      "inputLabel": "Nombre del protector"
    },
    "beneficialOwner": {
      "title": "Añadir el/los beneficiario(s) efectivo(s)",
      "inputLabel": "Nombre del beneficiario efectivo"
    },
    "incompleteAffiliationError": "Error al añadir entidades incompletas como afiliaciones"
  },
  "tfsaAccountCreation": {
    "title": "Cuenta de ahorro libre de impuestos",
    "subtitle": "¿Desea añadir un sucesor o beneficiario?",
    "addASuccessor": "Añadir a un sucesor",
    "successorName": "Nombre del sucesor",
    "relationshipToAccountHolder": "Relación con el titular de la cuenta",
    "addBeneficiaries": "Añadir beneficiarios",
    "beneficiaryName": "Nombre del beneficiario",
    "addAccount": "Añadir cuenta",
    "allocation": "Asignación"
  },
  "fhsaAccountCreation": {
    "title": "Cuenta de ahorro para la primera vivienda",
    "subtitle": "¿Desea añadir un sucesor o beneficiario?",
    "addASuccessor": "Añadir a un sucesor",
    "successorName": "Nombre del sucesor",
    "relationshipToAccountHolder": "Relación con el titular de la cuenta",
    "addBeneficiaries": "Añadir beneficiarios",
    "beneficiaryName": "Nombre del beneficiario",
    "addAccount": "Añadir cuenta",
    "allocation": "Asignación"
  },
  "rrspAccountCreation": {
    "title": "Plan de ahorro para la jubilación registrado",
    "relationshipToAccountHolder": "Relación con el titular de la cuenta",
    "addABeneficiary": "Añadir un beneficiario",
    "beneficiaryName": "Nombre del beneficiario",
    "addAccount": "Añadir cuenta",
    "allocation": "Asignación"
  },
  "relationship": "Relación",
  "jointAccountHolder": {
    "label": "Copropietario de la cuenta",
    "subLabel": "Las cuentas conjuntas deben tener un cotitular"
  },
  "jointCashCreation": {
    "title": "Efectivo conjunto",
    "name": "Nombre",
    "addAccount": "Añadir cuenta"
  },
  "createAccount": {
    "repCodeLabel": "Código de representante",
    "repCodeRequired": "Por favor seleccione un código de representante",
    "repCodePlaceholder": "Seleccione un código de representante",
    "repCodeHelpText": "Las cuentas se abrirán con este código de representante. Seleccione uno para continuar.",
    "repCodeOnlyOne": "Este es su único código de representante asignado.",
    "repCodeNoneAssigned": "No tiene códigos de representante activos asignados. Póngase en contacto con su administrador.",
    "repCodeNoAccess": "Necesita acceso al código de representante para abrir una cuenta. Póngase en contacto con su administrador."
  },
  "respAccountCreation": {
    "respSingleTitle": "Plan de ahorro para la educación registrado - Individual",
    "jointRespSingleTitle": "Plan conjunto de ahorro para la educación registrado - Individual",
    "jointRespFamilyTitle": "Plan conjunto de ahorro para la educación registrado - Familia",
    "respAdultTitle": "Plan de ahorro para la educación registrado - Adulto",
    "respFamilyTitle": "Plan de ahorro para la educación registrado - Familia",
    "subtitle": "¿Desea solicitar alguna de las siguientes subvenciones gubernamentales?",
    "basicCanadaEducationSavingsGrant": "Subvención básica de ahorro para la educación en Canadá",
    "additionalCESG": "CESG adicional",
    "canadaLearningBond": "Bono de aprendizaje de Canadá",
    "transferredFromAnotherInstitution": "Transferido desde otra institución",
    "transferDialogTitle": "Confirme su cuenta RESP",
    "transferDialogAccountTypeLabel": "Tipo de cuenta",
    "createNewAccount": "Crear nueva cuenta",
    "addAnAffiliate": "Añadir un afiliado",
    "respAccountsMustHaveAtLeastOneAffiliate": "Las cuentas RESP deben tener al menos 1 afiliado",
    "name": "Nombre",
    "affiliationType": "Tipo de afiliación",
    "relationshipToAccountHolder": "Relación con el titular de la cuenta",
    "allocation": "Asignación",
    "isLegalGuardian": "¿Es el titular de la cuenta el tutor legal del beneficiario?",
    "isCareGiver": "¿Es el titular de la cuenta el cuidador del beneficiario?",
    "linkGoalTitle": "Vincular la cuenta a una meta",
    "linkGoalSubtitle": "Esto genera una subcuenta para configurar el tema y el producto de su cartera. Puede optar por realizar este paso más tarde.",
    "goal": "Meta",
    "addAccount": "Añadir cuenta",
    "gender": "Género",
    "respAgeRestrictionError": "No se puede abrir una cuenta RESP para adultos debido a restricciones de edad",
    "updateBeneficiaryDobRequired": "Esta cuenta RESP ya no está marcada como transferida desde otra institución, por lo que sus beneficiarios deben ser menores de 21 años. Actualice la fecha de nacimiento del beneficiario en el siguiente paso antes de añadir o modificar cualquier afiliado."
  },
  "customFieldValues": {
    "boolean": {
      "true": "Sí",
      "false": "No"
    }
  },
  "reviewAccount": {
    "type": "Tipo",
    "govGrants": "Subvenciones gubernamentales",
    "affiliates": "Afiliados",
    "accountType": "Tipo de cuenta",
    "custodian": "Custodio",
    "otherAffiliates": "Otros afiliados",
    "repCode": "Código de representante",
    "linkedGoals": "Metas vinculadas",
    "deleteAccountConfirmation": {
      "title": "Borrar {{accountDisplayTitle}} {{accountId}}",
      "bodyText": "¿Está seguro de que desea eliminar permanentemente {{accountDisplayTitle}} que termina en {{accountId}}? Esta acción no se puede deshacer."
    },
    "noWorkflowErrorMessage": "No se ha configurado ningún flujo de trabajo para editar la cuenta"
  },
  "reviewGoal": {
    "name": "Nombre de meta",
    "timeHorizon": "Horizonte temporal",
    "riskQuestion": "Nivel de riesgo",
    "accounts": "Cuentas",
    "portfolio": "Cartera",
    "goalCard": {
      "type": "Tipo",
      "time": "Hora",
      "target": "Meta"
    }
  },
  "sourceOfTransfer": {
    "bankAccount": "Cuenta bancaria - Transferencia electrónica de fondos (EFT)",
    "externalTransferIn": "Transferencia externa entrante",
    "transferToSubAccount": "Transferencia a otra cartera"
  },
  "externalTransferCreation": {
    "title": "Nueva transferencia externa entrante"
  },
  "transferMethod": "Método de transferencia",
  "transferMethodOptions": {
    "ALL_IN_CASH": "Todo en efectivo",
    "PARTIAL_CASH": "Efectivo parcial",
    "ALL_IN_KIND": "Todo en especie"
  },
  "transferTypeOptions": {
    "WITHDRAW": "Retirar",
    "DEPOSIT": "Depositar"
  },
  "addAnotherTransfer": "Añadir otra transferencia",
  "externalFinancialInstitution": "Institución financiera externa",
  "externalAccount": "Cuenta externa #",
  "amountToTransfer": "Importe a transferir",
  "addTransfer": "Añadir transferencia",
  "inboundAccount": "Cuenta entrante",
  "externalTransferReviewPanel": {
    "title": "Transferencia externa entrante: {{amount}} a {{accountType}}",
    "institution": "Institución:",
    "account": "Cuenta:",
    "transferMethod": "Método de transferencia:"
  },
  "bankAccountTransferCreation": {
    "title": "Nueva transferencia bancaria entrante",
    "institutionNumber": "Institución #",
    "transitNumber": "Tránsito #",
    "accountNumber": "Cuenta #",
    "amountToTransfer": "Importe a transferir",
    "makeRecurring": "Hacer recurrente",
    "enterAValidDate": "Introduzca una fecha válida",
    "transferDelayError": "Elija un día hábil válido a partir del {{date}}"
  },
  "bankAccountTransferReviewPanel": {
    "title": "Transferencia bancaria: {{amount}} a {{accountType}}",
    "type": "Tipo:",
    "deposit": "Depositar",
    "account": "Cuenta:",
    "bankAccount": "Cuenta bancaria:",
    "institutionNumber": "Institución #:",
    "accountNumber": "Cuenta #:",
    "transitNumber": "Tránsito #:",
    "recurring": "Recurrente:",
    "frequency": "Frecuencia:",
    "startDate": "Fecha de inicio:"
  },
  "workflowCancelModal": {
    "title": "¿Está seguro de que desea cancelar este flujo de trabajo?",
    "bodyText": "Esta acción no se puede deshacer.",
    "cleanupError": "Su flujo de trabajo ha sido cancelado, sin embargo, algunos de sus datos no se han podido eliminar/cancelar. Por favor, revíselos y póngase en contacto con el servicio de asistencia si es necesario."
  },
  "createAccountForGoal": {
    "createAccountError": "No se puede crear la cuenta bancaria. Vuelva a intentarlo o póngase en contacto con el servicio de asistencia.",
    "createSubAccountError": "No se puede crear la subcuenta. Vuelva a intentarlo o póngase en contacto con el servicio de asistencia.",
    "duplicateSubAccountWarning": "Se ha creado una nueva subcuenta. Es posible que tenga una subcuenta duplicada que se puede eliminar de forma segura.",
    "numAccountsBadge": "{{numAccounts}} cuenta(s)",
    "confirmDialog": {
      "createNewAccount": {
        "title": "Crear nueva cuenta",
        "body": "Ya existe una cuenta {{accountType}}. Esta acción creará otra cuenta {{accountType}} independiente."
      },
      "createNewSubAccount": {
        "title": "Crear subcuenta",
        "body": "Ya existe una cuenta {{accountType}}. Esta acción añadirá una subcuenta, lo que le permitirá aplicar diferentes estrategias de inversión dentro de una misma cuenta."
      },
      "dontShowAgain": "No volver a mostrar este mensaje"
    },
    "accountCreationMethodChoice": {
      "title": "El tipo de cuenta existe",
      "confirmButtonLabel": "Continuar",
      "body": "Ya existen {{numAccounts}} cuentas de tipo {{accountType}} vinculadas a esta meta. ¿Desea crear una nueva cuenta de tipo {{accountType}} o añadir una subcuenta dentro de la cuenta existente?",
      "bodyNoNewAccount": "Existen {{numAccounts}} cuentas {{accountType}} vinculadas a esta meta. Elija en qué cuenta desea añadir una subcuenta.",
      "newAccount": "Crear nueva cuenta {{accountType}}",
      "newSubAccount": "Añadir subcuenta dentro de {{accountName}} {{accountId}}"
    }
  },
  "createGoal": {
    "numGoalsBadge": "{{numGoals}} meta(s)",
    "goalCreationMethodChoice": {
      "title": "El tipo de meta existe",
      "confirmButtonLabel": "Continuar",
      "body": "Ya existe(n) {{numGoals}} meta(s) de tipo {{goalType}}. ¿Desea crear una nueva meta de tipo {{goalType}} o reutilizar una ya existente?",
      "bodyNoNewGoal": "Existe(n) {{numGoals}} {{goalType}} meta(s). Elija la meta que desea utilizar.",
      "existingGoal": "Vincular cuenta a {{goalName}} ({{marketValue}})",
      "newGoal": "Crear {{goalType}} meta"
    },
    "confirmDialog": {
      "existingGoalConfirmation": {
        "title": "Enlace a meta existente",
        "bodyText": "Ya existe(n) un(a) meta(s) {{goalType}}. Esta acción continuará utilizando la meta {{goalType}} existente."
      },
      "newGoalConfirmation": {
        "title": "Crear nueva meta",
        "bodyText": "Ya existe(n) meta(s) {{goalType}}. Esta acción creará otra meta {{goalType}} independiente."
      }
    }
  },
  "depositReview": {
    "fromBankAccount": "De cuenta bancaria",
    "toBankAccount": "A cuenta bancaria",
    "fromSubAccount": "De cartera",
    "toSubAccount": "A",
    "depositDisplayTitle": "{{amount}} a {{account}}",
    "unknownDepositType": "Desconocido",
    "toHolding": "Activo",
    "amount": "Importe",
    "reason": "Razón",
    "createDeposit": "Crear depósito",
    "continue": "Continuar",
    "updateDeposit": "Actualizar depósito",
    "createWithdraw": "Crear retirada",
    "addAnotherDeposit": "Añadir otro depósito",
    "updateWithdraw": "Actualizar retirada",
    "success": "Depósito creado correctamente",
    "failure": "Error al crear el depósito",
    "deny": "Depósito rechazado",
    "withdrawSuccess": "Retirada creada correctamente",
    "amountExceeds": "Se tratará de un retiro completo en el que todos sus fondos se transferirán a la cartera que haya elegido.",
    "amountExceedsWithdraw": "Se tratará de un retiro completo, en el que se retirarán todos sus fondos.",
    "fullTransfer": "Transferencia completa",
    "fullTransferWithCurrency": "Transferencia completa en {{currency}}",
    "ALL_IN_CASH": "Transferencia completa de efectivo",
    "PARTIAL_CASH": "Transferencia parcial de efectivo",
    "ALL_IN_KIND": "Todas las transferencias en especie",
    "financialInstitution": "Institución financiera",
    "accountNumber": "Número de cuenta",
    "accountType": "Tipo de cuenta",
    "transferType": "Tipo de transferencia",
    "schedule": "Calendario",
    "startsOn": "Se inicia en",
    "scheduledFor": "Programado para",
    "allInCashMessage": "Todos los activos de su cuenta de origen se venderán y transferirán en efectivo.",
    "partialCashMessage": "Introduzca la cantidad de efectivo que desea transferir. Los activos restantes permanecerán en su cuenta de origen.",
    "allInKindMessage": "Todos los activos se transferirán directamente, sin venderse (en su forma actual).",
    "federalTaxWithheld": "Impuestos federales retenidos",
    "stateTaxWithheld": "Impuestos estatales retenidos",
    "grossAmount": "Importe bruto",
    "error": "No se pudo crear la transferencia.",
    "couldNotCompleteAllDeposits": "No se han podido completar una o varias transferencias. Edite o elimine las transferencias fallidas para continuar.",
    "createTransferError": "No se pudo crear la transferencia. {{ message }}",
    "multiDepositDisabledError": "El depósito múltiple debe estar deshabilitado para las transferencias de depósito del custodio.",
    "deleteDepositConfirmation": {
      "title": "Eliminar depósito de {{depositDisplayTitle}}",
      "bodyText": "¿Está seguro de que desea eliminar el depósito de {{depositDisplayTitle}}? Esta acción no se puede deshacer."
    },
    "noWorkflowErrorMessage": "No se ha configurado ningún flujo de trabajo para editar el depósito",
    "depositNotFoundError": "Depósito no encontrado",
    "noDeposits": "No hay depósitos que revisar",
    "estimatedAmountLabel": "Importe estimado"
  },
  "withdrawReview": {
    "frequency": "Frecuencia",
    "startsOn": "Se inicia en",
    "startDate": "Fecha de inicio"
  },
  "personalInformation": {
    "underAgeOfMajorityMessage": "El cliente debe tener al menos {{MINUMUM_AGE}} años de edad.",
    "futureDateMessage": "La fecha no puede ser futura"
  },
  "residencyInformation": {
    "foreignTaxInformation": {
      "error": "Se requiere el número de identificación fiscal y el país.",
      "missingCountry": "Número de identificación fiscal requerido para {{country}}"
    },
    "taxIdType": "Tipo de identificación fiscal",
    "allowITIN": "Permitir el ITIN para clientes individuales",
    "allowITINni": "Permitir el ITIN para clientes no individuales",
    "taxIdOnlyApplicableIn": "Esta entrada del número de identificación fiscal solo es aplicable en Canadá o EE. UU.; consulte la configuración, organización, localización.",
    "taxIdExplanationIndividuals1": "Los clientes individuales deberán introducir {{type}}",
    "taxIdExplanationIndividuals2": "Los clientes individuales deberán introducir {{type1}} o {{type2}}",
    "taxIdExplanationNonIndividuals": "Los clientes no individuales deberán introducir {{type}}",
    "taxIdExplanationNonIndividuals2": "Los clientes no individuales deberán introducir {{type1}} o {{type2}}",
    "taxIdExplanationNonIndividuals3": "Los clientes no individuales deberán introducir {{type1}}, {{type2}} o {{type3}}",
    "customTaxIdLabelsEnable": "Etiquetas personalizadas",
    "customTaxIdLabelfor": "Etiqueta del campo {{type}}"
  },
  "subStepOptions": {
    "optionTypes": {
      "BASIC_OR_SELECT_FIELD": {
        "isSelectLabel": "Usar selecciones",
        "isDefaultSelectLabel": "Utilizar la lista de OneVest",
        "valueColLabel": "Asignado al valor"
      },
      "ADDITIONAL_INFO_FIELD": {
        "checkboxLabel": "Información adicional"
      },
      "DEFAULT_VALUE_FIELD": {
        "checkboxLabel": "Valor predeterminado"
      },
      "DISCLAIMER_INFO": {
        "checkboxLabel": "Descargo de responsabilidad"
      },
      "CUSTOM_LABELS_FIELD": {
        "checkboxLabel": "Etiqueta personalizada",
        "mainSwitch": "Cambio principal",
        "goalLabel": "Meta",
        "priceDateLabel": "Fecha de precio",
        "currencyLabel": "Moneda",
        "unitPriceLabel": "Precio unitario",
        "tenPercentAmountLabel": "Importe libre del 10%",
        "backEndFeePercentageLabel": "Porcentaje de comisión de salida",
        "marketValueLabel": "Valor de mercado",
        "grossRedemptionLabel": "Reembolso bruto",
        "backEndRedemptionFeeLabel": "Comisión de reembolso de salida",
        "grossProceedsLabel": "Ganancias brutas",
        "withholdingTaxLabel": "Retención de impuestos",
        "netAmountLabel": "Importe neto"
      }
    },
    "visibility": {
      "label": "Este paso del flujo de trabajo no es visible para los clientes"
    }
  },
  "updateAccount": {
    "jurisdiction": "Jurisdicción",
    "sourceOfFunds": "Origen de los fondos",
    "sourceOfFundsOptions": {
      "SELF": "Uno mismo",
      "SPOUSE": "Esposo/a",
      "USA_EMPLOYMENT_WAGES": " Salarios laborales",
      "USA_INHERITANCE_TRUST": " Herencia / Fideicomiso",
      "USA_LOTTERY_GAMING": "Lotería / Juegos de azar",
      "USA_RETIREMENT_FUNDS": "Fondos de jubilación",
      "USA_INVESTMENTS": "Inversiones",
      "USA_SPOUSAL_PARENTAL_SUPPORT": "Manutención conyugal / parental",
      "USA_GIFT": "Regalo",
      "USA_SAVINGS": "Ahorros",
      "USA_UNEMPLOYMENT_DISABILITY": " Desempleo / Discapacidad",
      "USA_LEGAL_SETTLEMENT": "Acuerdo legal",
      "USA_OTHER": "Otros"
    }
  },
  "subAccountTransferCreation": {
    "title": "Nueva transferencia a cartera existente",
    "from": "Desde",
    "to": "A"
  },
  "subAccountTransferReviewPanel": {
    "title": "Transferencia a cartera existente",
    "fromPortfolio": "De cartera",
    "toPortfolio": "A cartera",
    "amount": "Importe"
  },
  "idVerificationSkipDialog": {
    "title": "¿Está seguro?",
    "content1": "Está optando por omitir el proceso de verificación de identidad, lo que significa que no podrá realizar depósitos hasta que este se haya completado. Para completar la verificación de identidad y comenzar a invertir, póngase en contacto con nuestro",
    "content2": " equipo de asistencia,",
    "content3": " que le ayudará a verificar su identidad.",
    "cancel": "Cancelar",
    "continue": "Continuar"
  },
  "value": "Valor",
  "cancelWorkflow": "Cancelar flujo de trabajo",
  "states": {
    "ACTIVE": "Activo",
    "CANCELED": "Cancelado",
    "COMPLETED": "Completado"
  },
  "depositTypeOptions": {
    "EFT": "EFT",
    "INTERNAL_TRANSFER": "Transferencia interna",
    "EXTERNAL_TRANSFER": "Transferencia externa"
  },
  "noDepositTypeSelected": "No se ha seleccionado ningún tipo de depósito. Seleccione un tipo de depósito.",
  "subStepTypes": {
    "ACCOUNTS": "Cuentas",
    "ACTION_ACTIVATE_ALL_SUB_ACCOUNTS": "Activar todas las subcuentas",
    "APPROVAL": "Aprobación",
    "ASSIGN_PORTFOLIO_TO_SUB_ACCOUNT": "Asignar cartera a subcuenta",
    "ARCHIVE_OBJECTS": "Archivar objetos",
    "BANK_ACCOUNT_INFORMATION": "Información de cuenta bancaria",
    "CREATE_ACCOUNT_FOR_GOAL": "Crear cuenta para meta",
    "CREATE_ACCOUNT": "Crear cuenta",
    "CREATE_GOAL": "Crear meta",
    "DEPOSIT_FORM": "Formulario de depósito",
    "DEPOSIT_REVIEW": "Revisión del depósito",
    "DEPOSIT_TYPE": "Tipo de depósito",
    "DOCUMENTS": "Documentos",
    "EDIT_ACCOUNT": "Editar cuenta",
    "EDIT_GOAL": "Editar meta",
    "EMPLOYMENT_INFORMATION": "Información laboral",
    "FINANCIAL_PROJECTIONS": "Proyecciones financieras",
    "GOALS": "Metas",
    "GOAL_RISK_QUESTION_1": "Pregunta sobre el riesgo del objetivo",
    "HOUSEHOLD": "Hogar",
    "INITIALIZE_HOUSEHOLD_MODEL_PORTFOLIO": "Inicializar la cartera modelo del hogar",
    "SELECT_HOUSEHOLD_PARENT_MODEL_PORTFOLIO": "Seleccionar la cartera modelo principal del hogar",
    "SELECT_MODEL_PORTFOLIO_EDIT_TYPE": "Seleccionar el tipo de edición de la cartera modelo",
    "DETACH_MODEL_PORTFOLIO": "Desvincular la cartera modelo",
    "EDIT_HOUSEHOLD_MODEL_PORTFOLIO_IPS": "Editar la declaración de política de inversión del hogar",
    "ADD_MODEL_PORTFOLIO_SECURITY_ALLOCATIONS": "Editar las asignaciones de valores",
    "REVIEW_ALLOCATIONS": "Revisar las asignaciones",
    "REVIEW_IPS_SUMMARY": "Revisar el resumen de la declaración de política de inversión",
    "EDIT_ACCOUNT_ALLOCATIONS": "Editar asignaciones de cuentas",
    "REVIEW_ACCOUNT_ALLOCATIONS": "Revisar asignaciones de cuentas",
    "APPLY_ACCOUNT_ALLOCATIONS": "Aplicar asignaciones de cuentas",
    "ACTION_TRANSITION_MODEL_CHANGE_PROPOSAL": "Transicionar la propuesta de cambio de modelo",
    "ID_VERIFICATION": "Verificación de ID",
    "INCOME_ASSETS_AND_DEBTS": "Ingresos, activos y deudas",
    "INVESTMENT_KNOWLEDGE": "Conocimientos sobre inversiones",
    "NON_INDIVIDUAL_INFORMATION": "Información no individual",
    "NON_INDIVIDUAL_SETUP": "Configuración no individual",
    "PERSONAL_INFORMATION": "Información personal",
    "PERSONS_OF_INTEREST": "Personas de interés",
    "PROJECTIONS": "Proyecciones",
    "RELATED_ENTITIES": "Entidades relacionadas",
    "RELATIONSHIP_INFORMATION": "Información de la relación",
    "RESIDENCY_INFORMATION": "Información de residencia",
    "REVIEW": "Revisión",
    "REVIEW_ACCOUNT": "Revisar cuenta",
    "REVIEW_BANK_ACCOUNT_INFORMATION": "Revisar la información de la cuenta bancaria",
    "REVIEW_GOAL": "Revisar meta",
    "REVIEW_PORTFOLIO_CHANGES": "Revisar los cambios en la cartera",
    "RISK_PROFILE": "Perfil de riesgo",
    "RISK_QUESTION_1": "Pregunta sobre riesgos 1",
    "RISK_QUESTION_2": "Pregunta sobre riesgos 2",
    "SUB_ACCOUNTS": "Subcuentas",
    "TRANSFERS": "Transferencias",
    "ACTION_ADD_FORM_DEFINITION": "Acción Añadir definición de formulario - Beta",
    "PREPARE_FORM_COMPLETIONS": "Preparación de formularios completos - Beta",
    "SIGN_FORM_COMPLETIONS": "Cumplimentación de formularios de registro - Beta",
    "MANAGE_FORM_COMPLETIONS": "Gestionar formularios completados - Beta",
    "MANAGE_SIGNERS": "Gestionar firmantes - Beta",
    "CREATE_INTEGRATION_FORM_PACK": "Crear paquete de formularios de integración - Beta",
    "SEND_INTEGRATION_FORM_PACK": "Enviar paquete de formularios de integración - Beta",
    "SYNCHRONOUS_INTEGRATION": "Integración sincrónica",
    "REDIRECT_HANDLER": "Controlador de redirección",
    "WITHDRAW_FORM": "Formulario de baja",
    "WITHDRAW_REVIEW": "Revisión de baja",
    "USER_VERIFICATION": "Verificación del usuario",
    "ACTION_AFFILIATE_INVITATION": "Acción: invitación para afiliados",
    "ACTION_INTEGRATION": "Acción Crear acuerdo de formulario de integración",
    "ACTION_NOTIFY": "Acción Notificar",
    "ACTION_UPDATE_USER": "Acción Actualizar usuario",
    "ACTION_UPDATE_ACCOUNT": "Acción Actualizar cuenta",
    "CREATE_ACCOUNT_GROUP": "Crear grupo de cuentas",
    "NET_WORTH": "Patrimonio neto",
    "COLLECT_SIGNERS": "Recopilar firmantes",
    "WORKFLOW_REVIEW": "Revisión del flujo de trabajo",
    "CALCULATOR": "Calculadora",
    "MULTI_PORTFOLIO_DEPOSIT": "Depósito de cartera múltiple"
  },
  "householdInitializeShells": {
    "noDraftSelected": "Aún no se ha seleccionado ningún modelo principal. Vuelva atrás para seleccionar uno antes de continuar.",
    "selectParentModelError": "No se pudo cargar el modelo de portafolio seleccionado. Inténtelo de nuevo.",
    "initializeButton": "Inicializar",
    "commitError": "No se pudo crear y adjuntar la cartera modelo. Inténtelo de nuevo.",
    "commitProposalPending": "Este hogar tiene un cambio de modelo propuesto pendiente de firma. Complételo o descártelo antes de cambiar la cartera modelo.",
    "commitWarning": "La cartera modelo se creó con advertencias.",
    "commitMissingData": "Faltan datos necesarios para inicializar. Vuelva atrás y seleccione de nuevo el modelo principal.",
    "commitBlockedAllocations": "Las asignaciones que aparecen abajo deben ajustarse antes de poder inicializar este hogar.",
    "modelName": {
      "label": "Nombre del modelo",
      "helpText": "El nombre de la copia del modelo propia de este hogar."
    },
    "summary": {
      "title": "Resumen",
      "parentModel": "Modelo principal",
      "tradingProcess": "Proceso de negociación"
    }
  },
  "householdModelPortfolioIps": {
    "saveError": "No se pudo guardar la declaración de política de inversión. Inténtelo de nuevo.",
    "applyWarning": "La declaración de política de inversión se guardó con advertencias.",
    "applyMissingData": "Faltan los datos necesarios para actualizar la cartera modelo. Cierre este flujo de trabajo e iníciela de nuevo desde el hogar.",
    "loadError": "No se pudo cargar la cartera modelo del hogar. Inténtelo de nuevo.",
    "missingModel": "Este hogar no tiene una cartera modelo que editar. Cierre este flujo de trabajo y vincule una primero.",
    "missingHousehold": "No se encontró el hogar que editar. Cierre este flujo de trabajo e iníciela de nuevo desde el hogar.",
    "summaryEmpty": "No se han registrado detalles de la política de inversión para esta cartera modelo.",
    "current": "Actual",
    "proposed": "Propuesta"
  },
  "discardModelChangeProposal": {
    "title": "¿Descartar este cambio propuesto?",
    "body": "Este flujo de trabajo tiene una propuesta de cambio de modelo abierta para el grupo familiar. Descartarla cancela la propuesta, incluida cualquier firma pendiente, y cierra este flujo de trabajo, de modo que el grupo familiar puede modificarse de nuevo desde el principio. Conservarla deja la propuesta abierta para que alguien la firme y el flujo de trabajo disponible para continuar.",
    "discard": "Descartar el cambio",
    "keep": "Conservarla"
  },
  "householdModelPortfolioAllocations": {
    "security": "Valor",
    "assetClass": "Clase de activo",
    "current": "Actual",
    "currentPercent": "Actual (%)",
    "currentValue": "Actual ($)",
    "proposed": "Propuesta",
    "proposedPercent": "Propuesta (%)",
    "proposedValue": "Propuesta ($)",
    "change": "Cambio",
    "total": "Total",
    "newHolding": "Nuevo",
    "removedHolding": "Eliminado",
    "onlyChanges": "Mostrar solo los cambios",
    "empty": "Esta cartera modelo no tiene valores que revisar.",
    "nothingProposed": "Los valores propuestos están vacíos. Vuelva al paso de asignaciones y agregue al menos uno antes de continuar.",
    "doesNotAddUp": "Los valores propuestos no suman 100 %. Vuelva al paso de asignaciones y ajústelos antes de continuar.",
    "groupsDoNotAddUp": "Los valores de cada clase de activo deben sumar 100 % y cada valor debe pertenecer a una. Vuelva al paso de asignaciones y ajústelos antes de continuar.",
    "groupWeightsDoNotAddUp": "Las ponderaciones de las clases de activos deben sumar 100 % antes de poder cambiar esta cartera modelo. Vuelva al paso de asignaciones y defínalas.",
    "duplicateHolding": "El mismo valor aparece dos veces en los valores propuestos. Vuelva al paso de asignaciones y elimine el duplicado antes de continuar.",
    "initializeBlocked": {
      "empty": "Esta cartera modelo no tiene valores. Agregue al menos uno antes de inicializar.",
      "incompleteHolding": "A una fila le falta un valor. Seleccione uno para cada fila antes de inicializar.",
      "duplicateHolding": "El mismo valor aparece dos veces. Elimine el duplicado antes de inicializar.",
      "doesNotAddUp": "Los valores no suman 100 %. Ajústelos antes de inicializar.",
      "groupsDoNotAddUp": "Los valores de cada clase de activo deben sumar 100 % y cada valor debe pertenecer a una. Ajústelos antes de inicializar.",
      "groupWeightsDoNotAddUp": "Las ponderaciones de las clases de activos deben sumar 100 %. Defínalas antes de inicializar.",
      "duplicateTaxRank": "Dos valores tienen el mismo rango fiscal. Asigne a cada uno su propio rango antes de inicializar.",
      "taxRankGaps": "Los rangos fiscales deben comenzar en 1 y seguir en orden sin saltos. Ajústelos antes de inicializar."
    },
    "missingCurrent": "Este flujo de trabajo ya no sabe qué tiene el hogar hoy, que es contra lo que se debe firmar un cambio de modelo. Cierre este flujo de trabajo e iníciela de nuevo desde el hogar.",
    "saveError": "No se pudo guardar el cambio de modelo propuesto. Inténtelo de nuevo.",
    "submitError": "No se pudo enviar el cambio de modelo para su firma. Inténtelo de nuevo.",
    "notEditable": "Este hogar ya tiene un cambio de modelo pendiente de firma. Complételo o cancélelo antes de proponer otro.",
    "missingData": "Faltan los datos necesarios para proponer un cambio de modelo. Cierre este flujo de trabajo e iníciela de nuevo desde el hogar.",
    "changeCount_one": "{{count}} de {{total}} valores cambiados.",
    "changeCount_other": "{{count}} de {{total}} valores cambiados.",
    "noChanges": "Ninguno de los valores cambió.",
    "currentBalance": "Valor de mercado total",
    "portfolioPercentSubheader": "Cartera %",
    "percentageViewPortfolio": "Cartera %",
    "percentageViewAssetClass": "Dentro de la clase %",
    "portfolioAllocationSummary": "Asignación de cartera",
    "noChangesInView": "No se cambiaron valores en esta vista."
  },
  "householdDetach": {
    "detachButton": "Desvincular",
    "detachError": "No se pudo desvincular la cartera modelo. Inténtelo de nuevo.",
    "archiveWarning": "La cartera modelo se desvinculó, pero no se pudo archivar la copia del hogar. Se limpiará la próxima vez que se adjunte una cartera modelo.",
    "archiveProposalPending": "La cartera modelo se desvinculó, pero no se pudo archivar la copia del hogar mientras un cambio de modelo propuesto está pendiente de firma. Complete o descarte ese cambio para limpiarla.",
    "missingHousehold": "No se encontró el hogar del que desvincular. Cierre este flujo de trabajo e iníciela de nuevo desde el hogar."
  },
  "selectModelPortfolioEditType": {
    "customizedSingleAccountTooltip": "Las asignaciones personalizadas requieren más de una cuenta en el hogar. Para cambiar las asignaciones de este hogar, edite en su lugar las asignaciones del hogar."
  },
  "formArchived": "Formulario archivado correctamente",
  "formReuploaded": "Formulario recargado correctamente",
  "formArchiveError": "Error al archivar el formulario",
  "formReuploadError": "Error al volver a cargar el formulario",
  "formPdfLoadError": "El PDF no se ha podido cargar tras el número máximo de intentos",
  "updateBranch": "Actualizar sucursal",
  "addCondition": "Añadir condición",
  "removeCondition": "Eliminar condición",
  "deleteBranch": "Borrar sucursal",
  "sections": "Secciones",
  "unsavedChanges": "Cambios no guardados",
  "editWorkflow": "Editar flujo de trabajo",
  "conditionOn": "Condición basada en",
  "client": "Cliente",
  "contextAccount": "Cuenta en contexto",
  "contextGoal": "Meta en contexto",
  "contextTransfer": "Transferencia en contexto",
  "contextHousehold": "Hogar en contexto",
  "user": "Clientes",
  "uploadSignedForm": "Cargue el formulario firmado a continuación",
  "conditionFieldInfo": "Puede preseleccionar cualquier atributo de objeto del menú desplegable; de lo contrario, escriba cualquier clave de campo personalizada",
  "settings": "Configuración",
  "prepareFormCompletions": {
    "title": "Preparación de paquetes de formularios",
    "description": "Esto preparará todos los formularios necesarios para la firma. El proceso puede tardar unos minutos en completarse.",
    "householdPrimaryUserNotFound": "No se pudo encontrar el usuario principal de este hogar."
  },
  "createIntegrationFormPack": {
    "title": "Creación de un paquete de formularios",
    "description": "Esto creará el paquete de formularios para firmar. El proceso puede tardar unos minutos en completarse."
  },
  "sendIntegrationFormPack": {
    "title": "Envío de invitaciones para el paquete de formularios",
    "description": "Esto enviará las invitaciones para el paquete de formularios a todos los firmantes. Este proceso puede tardar unos minutos en completarse."
  },
  "settingsModal": {
    "title": "Configuración del flujo de trabajo",
    "saveButton": "Guardar",
    "displayCloseButton": "Mostrar el botón Cerrar (X) en los pasos del flujo de trabajo",
    "cancelOnClose": "Al cerrar (X), cancele el flujo de trabajo y elimínelo del perfil",
    "archiveObjectsOnClose": [
      "Al cancelar, archive los siguientes objetos que se crearon en el flujo de trabajo (cuenta, meta, subcuenta y/o transferencia).",
      "Esto no se aplicará a la edición de objetos."
    ],
    "applicableRoleProfiles": "Puede activar el flujo de trabajo",
    "applicableRoleProfilesSupport": "Por defecto, todos los perfiles de rol pueden activar flujos de trabajo. Seleccione perfiles específicos para restringir."
  },
  "manageSigners": {
    "manageSigners": "Gestionar firmantes",
    "description": "Se están cargando los firmantes requeridos.",
    "useOrgUser": "Usar usuario de la organización",
    "firstName": "Nombre",
    "lastName": "Apellido",
    "email": "Correo electrónico",
    "signingOrder": "Orden de firmas",
    "user": "Usuario",
    "restrictedByRole": "Limitado por funcion",
    "restrictedToRoles": "Restringido a roles",
    "clientSigner": "Firmante del cliente",
    "signingDocuments": "Firmando:",
    "linkedSigner": "Enviado como un solo firmante, orden {{order}}"
  },
  "visibility": {
    "label": "Esta acción solo será visible para los usuarios con los permisos adecuados"
  },
  "enableCallToActions": "Habilitar llamadas a la acción",
  "callToActions": "Llamadas a la acción",
  "action": "Acción",
  "buttonVariant": "Variante de botón",
  "buttonColor": "Color del botón",
  "addAction": "Añadir acción",
  "primary": "Primario",
  "destructive": "Destructivo",
  "filled": "Llenado",
  "tonal": "Tonal",
  "outlined": "Esbozado",
  "text": "Texto",
  "buttonLabel": "Etiqueta del botón",
  "changeToBasicWorkflow": "Cambiar al flujo de trabajo básico",
  "changeToComplexWorkflow": "Cambiar a un flujo de trabajo complejo",
  "addNewForm": "Añadir nuevo formulario",
  "formDefinition": "Definición del formulario",
  "prepare": "Preparar",
  "fiscalYearForRecurringContributions": "Las contribuciones recurrentes siempre se aplican al año fiscal actual. El sistema se actualizará automáticamente al nuevo año fiscal el 1 de enero. Para contribuir a un año anterior (permitido hasta el 15 de abril), utilice un depósito único o con fecha futura.",
  "netWorthDetails": {
    "CASH": "Detalles del efectivo",
    "EXTERNAL_INVESTMENT_ACCOUNT": "Detalles de las inversiones",
    "REAL_ESTATE": "Detalles inmobiliarios",
    "VEHICLES": "Detalles de los vehículos",
    "VALUABLES": "Detalles de objetos de valor",
    "OTHER_ASSET": "Detalles de otros activos",
    "OTHER_LIABILITY": "Detalles de otros pasivos",
    "LOANS": "Detalles de los préstamos",
    "MORTGAGE": "Detalles de la hipoteca",
    "CREDIT_CARD": "Datos de la tarjeta de crédito",
    "confirmButton": "Confirmar",
    "addMoreButton": "Añadir más"
  },
  "archiveObjects": {
    "accounts": "Cuentas",
    "goals": "Objetivos",
    "subAccounts": "Subcuentas",
    "transfers": "Transferencias",
    "scheduledTransfers": "Transferencias programadas",
    "externalTransfers": "Transferencias externas",
    "custodianDepositTransfers": "Transferencias de depósito del custodio",
    "type": "Tipo",
    "state": "Estado",
    "name": "Nombre",
    "goalName": "Objetivo",
    "accountType": "Tipo de cuenta",
    "accountId": "ID de cuenta",
    "amount": "Monto",
    "currency": "Moneda",
    "frequency": "Frecuencia",
    "startDate": "Fecha de inicio",
    "institution": "Institución",
    "transferMethod": "Método de transferencia",
    "total": "Total: {{count}}",
    "archivingMessage": "Archivando {{objects}} creados durante este flujo de trabajo.",
    "noObjectsToArchive": "No se crearon objetos durante este flujo de trabajo o ya han sido archivados, no hay nada que archivar.",
    "archiveObjectsWarning": "Se archivarán los siguientes objetos:"
  },
  "redirectHandler": {
    "redirecting": "Redirigiendo a la verificación...",
    "successTitle": "Transferencia verificada exitosamente",
    "successSubtitle": "Su transferencia de depósito ha sido verificada y está siendo procesada.",
    "failureTitle": "La verificación no fue exitosa",
    "failureSubtitle": "No se pudo completar la verificación.",
    "cancelling": "Verificación fallida, cancelando transferencia...",
    "closedTabTitle": "La verificación no fue completada",
    "closedTabSubtitle": "La página de verificación fue cerrada antes de que pudiera completarse.",
    "retry": "Reintentar verificación",
    "cancel": "Cancelar transferencia",
    "close": "Cerrar",
    "cancelSuccess": "Transferencia cancelada exitosamente.",
    "cancelError": "No se pudo cancelar la transferencia. Por favor, inténtelo de nuevo."
  },
  "newSectionName": "Nueva Sección",
  "noDepositTypeSelectedWarning": "No se seleccionó ningún tipo de depósito. No se creará ningún depósito.",
  "incompleteSignerInfo": "Se ha introducido información incompleta para un firmante.",
  "unableToRedirectForVerification": "No se puede redirigir para la verificación.",
  "exampleData": {
    "assetClasses": {
      "alternativeInvestments": "Inversiones alternativas",
      "fixedIncome": "Renta fija",
      "equities": "Renta variable",
      "realAssets": "Activos reales"
    },
    "testDocument": "Documento de prueba"
  },
  "documentsSubStep": {
    "title": "Firme sus documentos",
    "subtitle": "Revise los documentos y fírmelos"
  },
  "assignPortfolioToSubAccountSubStep": {
    "title": "¿Qué tema se adapta mejor a su meta de inversión?",
    "subtitle": "Por favor, seleccione su preferencia. Puede cambiarla en cualquier momento.",
    "skipHouseholdPortfolioError": "No se puede omitir la asignación de cartera. Por favor, inténtelo de nuevo.",
    "missingSubAccountError": "No pudimos encontrar la subcuenta a la que asignar una cartera. Por favor, vuelva e inténtelo de nuevo, o póngase en contacto con el servicio de asistencia."
  },
  "createAccountForGoalSubStep": {
    "title": "¿Con qué cuenta le gustaría empezar?",
    "subtitle": "El tipo de cuenta que seleccione puede afectar los impuestos que pague sobre sus rendimientos de inversión."
  },
  "unsignedDocumentsWorkflow": {
    "stepName": "Firmar documentos"
  },
  "depositWorkflow": {
    "stepName": "Depositar fondos",
    "reviewStepName": "Revisar y enviar",
    "depositType": {
      "title": "¿Qué tipo de depósito le gustaría hacer?",
      "eft": "Transferencia electrónica de fondos",
      "internalTransfer": "Cartera existente",
      "externalTransfer": "Cuenta externa"
    },
    "depositForm": {
      "title": "Depositar fondos",
      "from": "Desde",
      "to": "A",
      "schedule": "Calendario",
      "starting": "A partir de",
      "financialInstitution": "Institución financiera",
      "accountNumber": "Número de cuenta",
      "accountType": "Tipo de cuenta",
      "transferType": "Tipo de transferencia",
      "contributionYear": "Año de contribución",
      "amount": "Importe",
      "manualBankAccountLinking": "Vinculación manual de cuenta bancaria",
      "allowDocumentUpload": "Permitir la carga de documentos",
      "automatedBankAccountLinking": "Vinculación automatizada de cuenta bancaria"
    },
    "depositReview": {
      "title": "Revisar y enviar",
      "eftDisclaimer": "Espere que el importe se retire de su cuenta en un plazo de 1 a 2 días hábiles.",
      "internalTransferDisclaimer": "Espere que el importe se deposite en su cuenta en un plazo de 3 días hábiles.",
      "externalTransferDisclaimer": "Por la presente, usted solicita la transferencia de su cuenta y sus inversiones según lo descrito anteriormente. Usted entiende que puede incurrir en una tarifa de transferencia de salida cobrada por su institución cedente, así como otras tarifas y cargos de solicitud."
    }
  },
  "withdrawWorkflow": {
    "stepName": "Retirar fondos",
    "reviewStepName": "Revisar y enviar",
    "withdrawForm": {
      "title": "Retirar fondos",
      "to": "A",
      "schedule": "Calendario",
      "from": "Desde",
      "amount": "Importe",
      "reason": "Razón"
    },
    "withdrawReview": {
      "title": "Revisar y enviar"
    }
  },
  "scheduleWithdrawWorkflow": {
    "stepName": "Retirar fondos",
    "reviewStepName": "Revisar y enviar",
    "withdrawForm": {
      "title": "Retirar fondos",
      "to": "A",
      "schedule": "Calendario",
      "from": "Desde",
      "amount": "Importe",
      "reason": "Razón"
    },
    "withdrawReview": {
      "title": "Revisar y enviar"
    }
  },
  "createGoalWorkflow": {
    "stepName": "Nueva meta",
    "createGoal": {
      "title": "¿Cuál es su nueva meta de inversión?"
    },
    "timeHorizon": {
      "title": "¿Cuándo le gustaría retirar sus fondos?",
      "subtitle": "Asuma que ha logrado su meta. ¿Qué horizonte temporal se ajusta mejor a cuándo desea acceder a la mayor parte de sus fondos?"
    },
    "targetAmount": {
      "title": "¿Cuál es su importe objetivo?",
      "subtitle": "Esto nos ayuda a recomendar los objetivos de ahorro adecuados para alcanzar su meta. Una estimación está bien."
    },
    "goalRiskQuestion": {
      "title": "¿Cuánto riesgo está dispuesto a asumir con esta meta?",
      "subtitle": "Para esta meta específica, ¿cuánto busca maximizar la recompensa en comparación con el riesgo que le gustaría asumir?",
      "level1": "No estoy dispuesto a perder nada",
      "level3": "Estoy dispuesto a soportar algunas pérdidas a corto plazo a cambio de un potencial de rendimiento moderado",
      "level5": "Estoy dispuesto a soportar mayores pérdidas a corto plazo a cambio del mayor potencial de rentabilidad"
    },
    "goalExitedSuccess": "La creación de la meta se ha cerrado correctamente",
    "errorClosingGoal": "Error al cerrar la meta"
  },
  "createEntityWorkflow": {
    "stepName": "Crear entidad",
    "typeSelect": {
      "title": "¿Qué tipo de entidad le gustaría crear?",
      "individual": "Individual",
      "nonIndividual": "No individual"
    },
    "nonIndividualTypeSelect": {
      "title": "¿Qué tipo de entidad no individual le gustaría crear?",
      "publiclyListedEntity": "Entidad que cotiza en bolsa",
      "privateCompany": "Empresa privada",
      "partnership": "Sociedad",
      "soleProprietorship": "Empresa unipersonal",
      "trust": "Fideicomiso",
      "investmentFund": "Fondo de inversión",
      "regulatedEntity": "Entidad regulada",
      "other": "Otro"
    },
    "entityCreation": {
      "title": "Creación de entidad",
      "email": "Correo electrónico",
      "firstName": "Nombre",
      "middleName": "Segundo nombre",
      "lastName": "Apellido",
      "entityName": "Nombre de la entidad"
    }
  },
  "createSubAccountWorkflow": {
    "stepName": "Nueva meta",
    "editAccount": {
      "title": "Introduzca la información de su cuenta"
    }
  },
  "createSubAccountFromAccountWorkflow": {
    "stepName": "Nueva cartera",
    "createSubAccount": {
      "title": "¿Cuál es su meta de inversión?",
      "subtitle": "Seleccione una meta para vincularla con su cartera."
    }
  },
  "createModelPortfolioWorkflow": {
    "stepName": "Crear cartera modelo",
    "choosePortfolioType": {
      "title": "¿Cómo desea crear su modelo?",
      "subtitle": "Puede crear una cartera modelo desde cero o utilizar una plantilla preexistente.",
      "fromScratchLabel": "Crear desde cero",
      "fromScratchDescription": "Añada valores del catálogo de productos y establezca el porcentaje objetivo y la clasificación fiscal, todo desde la interfaz de usuario del creador de modelos.",
      "fromTemplateLabel": "Crear a partir de una plantilla de activos",
      "fromTemplateDescription": "Utilice una plantilla preexistente de diferentes asignaciones de activos y asigne los valores subyacentes de acuerdo con la plantilla y su estrategia."
    },
    "selectTemplate": {
      "label": "Seleccionar plantilla de activos",
      "description": "Cree modelos únicos a partir de asignaciones de clases de activos preestablecidas, lo que permite tanto la coherencia como la flexibilidad con sus estrategias.",
      "templateSelectorLabel": "Nombre de la plantilla",
      "assetClassAllocationLabel": "Asignación de clases de activos"
    },
    "createTemplate": {
      "label": "Crear plantilla de activos",
      "description": "Cree modelos únicos a partir de asignaciones de clases de activos preestablecidas, lo que permite tanto la coherencia como la flexibilidad con sus estrategias.",
      "templateNameLabel": "Nombre de la plantilla",
      "templateDescriptionLabel": "Descripción de la plantilla",
      "assetClassLabel": "Clase de activo",
      "targetLabel": "Objetivo",
      "buttonSaveForLater": "Guardar para más tarde"
    },
    "addDetails": {
      "title": "Añadir detalles del modelo",
      "strategyLabel": "Estrategia del modelo",
      "translatedNameLabel": "Nombre del modelo",
      "translatedPortfolioDescriptionLabel": "Descripción del modelo",
      "translatedInvestmentObjectiveLabel": "Objetivo de inversión",
      "riskProfileNameLabel": "Perfil de riesgo",
      "themeIdLabel": "Familia de modelos",
      "suggestableLabel": "Sugerible",
      "zeroPercentCashLabel": "0% en efectivo",
      "lowThresholdScoreLabel": "Puntuación de umbral más baja",
      "suggestedMinScoreLabel": "Puntuación mínima",
      "suggestedMaxScoreLabel": "Puntuación máxima",
      "forecastedRateOfReturnLabel": "Tasa de rendimiento prevista",
      "forecastedStandardDeviationLabel": "Desviación estándar prevista",
      "riskReturnLevelLabel": "Nivel de riesgo/rendimiento",
      "urlLabel": "Enlace a detalles fundamentales",
      "buttonSaveForLater": "Guardar para más tarde",
      "driftSettingsLabel": "Configuración de desviación"
    },
    "addSecurities": {
      "title": "Añadir valores",
      "showSecurityAllocationTableLabel": "Tabla de asignación de valores",
      "securityAllocationChartLabel": "Gráfico de asignación de valores",
      "columnSecurityLabel": "Valor",
      "columnAssetClassLabel": "Clase de activo",
      "columnTaxRankLabel": "Clasificación fiscal",
      "columnTargetPercentageLabel": "% objetivo",
      "buttonRemoveSecurity": "Eliminar",
      "buttonSaveForLater": "Guardar para más tarde",
      "importFromCsv": "Importar desde CSV",
      "validateSecuritiesLabel": "Validar valores",
      "validateSecuritiesTitle": "Asignación incompleta",
      "validateSecuritiesBodyText": "Los valores de cada modelo deben sumar el 100%. Aunque puede finalizar esto más tarde, el modelo no se puede establecer como Activo ni asignar a una cartera hasta que el total sea correcto.",
      "validateSecuritiesCheckboxLabel": "Utilizar la asignación restante en efectivo y equivalentes nuevos o existentes"
    },
    "addIps": {
      "title": "Añadir declaración de política de inversión",
      "ipsLabel": "Declaración de política de inversión",
      "ipsDescriptionLabel": "Descripción",
      "ipsObjectiveLabel": "Objetivo",
      "ipsLiquidityLabel": "Liquidez",
      "disclaimerLabel": "Descargo de responsabilidad",
      "assetClassesDistributionLabel": "Clases de activos",
      "buttonSaveForLater": "Guardar para más tarde"
    }
  },
  "createAccountGroupWorkflow": {
    "stepName": "Crear grupo de cuentas",
    "createAccountGroup": {
      "title": "Crear grupo de cuentas",
      "subtitle": "Cree un grupo de cuentas para organizar sus cuentas"
    }
  },
  "createAssetTemplateWorkflow": {
    "stepName": "Crear plantilla de activos",
    "createAssetTemplate": {
      "label": "Crear plantilla de activos",
      "description": "Cree modelos únicos a partir de asignaciones de clases de activos preestablecidas, lo que permite tanto la coherencia como la flexibilidad con sus estrategias.",
      "templateNameLabel": "Nombre de la plantilla",
      "templateDescriptionLabel": "Descripción de la plantilla",
      "assetClassAllocationLabel": "Asignación de clases de activos",
      "assetClassLabel": "Clase de activo",
      "targetLabel": "Objetivo",
      "buttonCreate": "Crear"
    }
  },
  "netWorthWorkflow": {
    "stepName": "Añadir patrimonio neto",
    "netWorth": {
      "title": "¿Cómo le gustaría añadir su activo o pasivo?",
      "subtitle": "Esto nos ayudará a comprender su situación financiera y a brindarle el mejor servicio posible.",
      "automaticLinkTitle": "Conectar automáticamente con su cuenta",
      "automaticLinkSubtitle": "Vincule de forma segura sus cuentas bancarias a través de nuestro proveedor para sincronizar instantáneamente su información financiera.",
      "manualLinkTitle": "Introducir información manualmente",
      "manualLinkSubtitle": "Rellene toda la información requerida para introducir y gestionar manualmente sus datos financieros."
    }
  },
  "regenerateForms": {
    "button": "Regenerar formularios",
    "title": "Regenerar formularios",
    "body": "Esto cancelará el paquete de firmas actual. Cualquier firma pendiente se perderá y los firmantes deberán firmar de nuevo. ¿Desea continuar?",
    "confirm": "Cancelar paquete y regenerar",
    "cancel": "Mantener formularios actuales"
  },
  "calculator": {
    "input": {
      "title": "Entrada"
    },
    "results": {
      "title": "Resultados",
      "positionDetail": "Posición actual",
      "summary": "Resumen de reembolso",
      "exchangeRate": "Tipo de cambio: 1 CAD = {{rate}} USD",
      "priceDate": "Fecha de precio:",
      "currency": "Moneda base:",
      "unitPrice": "Precio unitario:",
      "tenPercentAmount": "Importe libre del 10% en dólares:",
      "backEndFeePercentage": "Porcentaje de comisión de salida:",
      "marketValue": "Valor de mercado:",
      "grossRedemption": "Reembolso bruto:",
      "backEndRedemptionFee": "Comisión de reembolso de salida:",
      "grossProceeds": "Ganancias brutas:",
      "withholdingTax": "Retención de impuestos:",
      "netAmount": "Importe neto:"
    },
    "redeem": "Reembolsar",
    "selectFund": "Seleccionar fondo",
    "amountType": "Tipo de importe",
    "selectAccount": "Seleccionar cuenta",
    "fund": "Fondo",
    "removeFund": "Eliminar fondo",
    "addFund": "Añadir fondo",
    "calculate": "Calcular",
    "clear": "Borrar",
    "download": "Descargar PDF",
    "noSecuritiesToRedeem": "Esta cuenta no tiene valores para reembolsar.",
    "redeemModes": {
      "single": "Un solo fondo",
      "multiple": "Múltiples fondos",
      "entire": "Cuenta completa"
    },
    "amountTypes": {
      "allShares": "Todas las acciones",
      "shares": "Acciones/Unidades",
      "dollarAmount": "Dólares - bruto",
      "dollarNetAmount": "Dólar - neto",
      "annualFreeAllocation": "Asignación anual gratuita (10% gratuito)",
      "dscFree": "DSC libre (Unidades vencidas y 10% gratuito)"
    },
    "errors": {
      "dollarExceed": "El importe excede el valor de retiro.",
      "sharesExceed": "El importe excede la cantidad en posesión."
    },
    "pdfPreview": {
      "title": "Descargar PDF",
      "fileName": "Nombre del archivo",
      "save": "Guardar PDF",
      "cancel": "Cancelar",
      "generateError": "No se pudo generar la vista previa del PDF. Inténtelo de nuevo.",
      "saveError": "No se pudo guardar el PDF. Inténtelo de nuevo."
    },
    "title": "Calculadora de reembolso",
    "amountLabels": {
      "amountRequired": "Importe requerido",
      "numberOfShares": "Número de acciones"
    },
    "error": "No se pueden mostrar datos"
  },
  "signFormCompletions": {
    "resendForSignature": "Volver a enviar para firma",
    "resendConfirmTitle": "¿Volver a enviar para firma?",
    "resendConfirmBody": "Esto enviará una nueva notificación de firma a los firmantes pendientes. Se mantendrá cualquier progreso de firma en este paquete.",
    "resendSuccess": "Paquete de formularios reenviado para firma.",
    "resendError": "No se pudo reenviar el paquete de formularios. Intente regenerar los formularios si el problema persiste."
  },
  "editAccountAllocations": {
    "unavailable": "No se pudieron cargar las asignaciones de cuentas de este hogar.",
    "stagingFailed": "No se pudieron guardar las asignaciones de las cuentas. Inténtelo de nuevo."
  },
  "reviewAccountAllocations": {
    "approve": "Aprobar",
    "unavailable": "No se pudieron cargar las asignaciones de cuentas de este hogar.",
    "changeCount_one": "Cambia {{count}} asignación.",
    "changeCount_other": "Cambian {{count}} asignaciones.",
    "noChanges": "No cambia ninguna asignación.",
    "blocked": {
      "MISSING_STAGING": "No hay asignaciones editadas para revisar. Vuelva atrás y continúe desde el editor.",
      "STALE_REPORT": "La cartera de este hogar se actualizó después de la edición. Vuelva atrás y edite las asignaciones de nuevo.",
      "MEMBERSHIP_CHANGED": "Las cuentas de este hogar cambiaron después de la edición ({{accounts}}). {{restart}}",
      "MEMBERSHIP_CHANGED_unnamed": "Las cuentas de este hogar cambiaron después de la edición. {{restart}}",
      "BASELINE_CHANGED": "Las asignaciones de este hogar cambiaron después de la edición, por ejemplo en la pestaña Cartera. {{restart}}",
      "INVALID_ACCOUNT_TOTALS": "Las asignaciones de una cuenta ya no suman 100 %. {{restart}}"
    },
    "restart": {
      "cancel": "Cancele y comience una nueva edición.",
      "close": "Cierre este flujo de trabajo y comience uno nuevo."
    }
  },
  "applyAccountAllocations": {
    "title": "Aplicar asignaciones de cuentas",
    "applying": "Aplicando asignaciones…",
    "retry": "Reintentar",
    "startAgain": "Inicie una nueva edición de asignaciones para continuar.",
    "accountsAdded": "Cuentas agregadas",
    "accountsRemoved": "Cuentas eliminadas",
    "accountNoLongerInHousehold": "Una cuenta que ya no está en este hogar",
    "blocked": {
      "MISSING_SNAPSHOT": "No hay ninguna asignación firmada que aplicar para este hogar.",
      "STALE_REPORT": "La cartera de este hogar se reemplazó después de preparar la asignación, por lo que no se puede aplicar la asignación firmada.",
      "MEMBERSHIP_CHANGED": "Las cuentas de este hogar cambiaron después de preparar la asignación, por lo que no se puede aplicar la asignación firmada.",
      "BASELINE_CHANGED": "Las asignaciones de este hogar se modificaron después de preparar la asignación, por lo que no se puede aplicar la asignación firmada."
    },
    "errors": {
      "NOT_ACCESSIBLE": "No tiene permiso para modificar las asignaciones de este hogar. Solicite acceso a un administrador y vuelva a intentarlo.",
      "NOT_CUSTOMIZED": "La cartera de este hogar no estaba lista para asignaciones personalizadas. Vuelva a intentarlo para aplicarlas de nuevo.",
      "WRONG_REPORT_MEMBER": "Las cuentas de este hogar no coinciden con la asignación firmada. Vuelva a intentarlo para verificarlas de nuevo."
    }
  },
  "downloadAllForms": "Descargar todos los formularios",
  "downloadAllFormsFileName": "Nombre del archivo Zip",
  "downloadAllFormsError": "No se pudieron descargar los formularios",
  "downloadAllFormsPartialError": "Algunos formularios no se pudieron descargar",
  "workflowLaunch": {
    "errors": {
      "missingId": "No se pudo iniciar el flujo de trabajo porque no se pudo determinar el propietario.",
      "unsupported": "Este flujo de trabajo no se puede iniciar para este tipo de registro.",
      "createFailed": "No se pudo iniciar el flujo de trabajo para este registro. Verifique que aún exista y que usted tenga acceso a él."
    }
  },
  "workflowObjectType": "Tipo de objeto",
  "workflowObjectTypes": {
    "USER": "Usuario",
    "ACCOUNT": "Cuenta",
    "GOAL": "Meta",
    "SUB_ACCOUNT": "Subcuenta",
    "HOUSEHOLD": "Hogar",
    "ACCOUNT_GROUP": "Grupo de cuentas"
  },
  "contextSubAccount": "Subcuenta en contexto"
}
